import { createSlice } from "@reduxjs/toolkit";
import { ILocationTrials } from "packages/lib-utils";

// Define the TS type for the counter slice's state
export interface DataCollectionState {
  trials: ILocationTrials[] | null;
}

// Define the initial value for the slice state
const initialState: DataCollectionState = {
  trials: null,
};
export const DataCollectionSlice = createSlice({
  name: "DataCollection",
  initialState,
  reducers: {
    updateTrialsList: (state, action) => {
      state.trials = action.payload;
    },
  },
});

// Export the generated action creators for use in components
export const { updateTrialsList } = DataCollectionSlice.actions;

// Export the slice reducer for use in the store configuration
export default DataCollectionSlice.reducer;
